import React from "react";
import styles from "./Pricing.module.css";
import "../i18n";
import { useTranslation } from "react-i18next";
import { poster as posterImage, puzzle as puzzleImage } from "../assets";

const Pricing: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isTurkish = i18n.language?.toLowerCase().startsWith("tr");
  const whatsappHref = isTurkish
    ? "https://wa.me/905016566778"
    : "https://wa.me/77072179227";

  const regular = t("pricing.regular", { returnObjects: true }) as any;
  const featured = t("pricing.featured", { returnObjects: true }) as any;
  const poster = t("pricing.poster", { returnObjects: true }) as any;
  const puzzle = t("pricing.puzzle", { returnObjects: true }) as any;

  return (
    <section className={styles.pricing}>
      <div className={styles.inner}>
        <h2 className={styles.title}>{t("pricing.title")}</h2>
        <p className={styles.subtitle}>{t("pricing.subtitle")}</p>
        <div className={styles.cards}>
          <div className={styles.card}>
            <h3 className={styles.planName}>{regular.planName}</h3>
            <div className={styles.priceRow}>
              <span className={styles.oldPrice}>{regular.oldPrice}</span>
              <span className={styles.price}>{regular.price}</span>
            </div>
            <ul className={styles.features}>
              {regular.features.map((f: string, i: number) => (
                <li key={i} className={styles.featureItem}>
                  <span className={styles.check}>✓</span>
                  {f}
                </li>
              ))}
            </ul>
            <a href={whatsappHref} className={styles.btnOutline}>
              {regular.button}
            </a>
          </div>

          <div className={`${styles.card} ${styles.cardFeatured}`}>
            <div className={styles.hotBadge}>{featured.hotBadge}</div>
            <h3 className={styles.planName}>{featured.planName}</h3>
            <div className={styles.priceRow}>
              <span className={styles.oldPriceDark}>{featured.oldPrice}</span>
              <span className={styles.priceBig}>{featured.price}</span>
            </div>
            <ul className={styles.features}>
              {featured.features.map((f: string, i: number) => (
                <li key={i} className={styles.featureItemLight}>
                  <span className={styles.checkGold}>✓</span>
                  {f}
                </li>
              ))}
            </ul>
            <a href={whatsappHref} className={styles.btnFilled}>
              {featured.button}
            </a>
          </div>
        </div>
        <div className={styles.specialCards}>
          <div className={styles.specialItem}>
            <div className={styles.specialBadges}>
              <span className={styles.badgeType}>{poster.badge}</span>
              <span className={styles.badgeNew}>{poster.newBadge}</span>
            </div>
            <div className={styles.posterImgWrap}>
              <img
                src={posterImage}
                alt="Poster"
                className={styles.posterImg}
              />
            </div>
            <div className={styles.specialPriceRow}>
              <span className={styles.specialOldPrice}>{poster.oldPrice}</span>
              <span className={styles.specialNewPrice}>{poster.price}</span>
            </div>
          </div>
          <div className={styles.specialItem}>
            <div className={styles.specialBadges}>
              <span className={styles.badgeType}>{puzzle.badge}</span>
              <span className={styles.badgeNew}>{puzzle.newBadge}</span>
            </div>
            <div className={styles.puzzleImgWrap}>
              <img
                src={puzzleImage}
                alt="Puzzle"
                className={styles.puzzleImg}
              />
            </div>
            <div className={styles.specialPriceRow}>
              <span className={styles.specialOldPrice}>{puzzle.oldPrice}</span>
              <span className={styles.specialNewPrice}>{puzzle.price}</span>
            </div>
          </div>
        </div>
        <div className={styles.extras}>
          <div className={styles.extra}>
            <span className={styles.extraIcon}>⚡</span>
            <div>
              <strong>{t("pricing.extras.express.title")}</strong>
              <span>{t("pricing.extras.express.desc")}</span>
            </div>
          </div>
          <div className={styles.extra}>
            <span className={styles.extraIcon}>👶</span>
            <div>
              <strong>{t("pricing.extras.twoKids.title")}</strong>
              <span>{t("pricing.extras.twoKids.desc")}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
